import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import CustomizableList from "../../../reusableComponents/Lists/list22";
import Button from "../../../reusableComponents/buttons/button22";
import useEnrolledCourses from "../../../../collabs/dashboard+learnings/enrolledCourses/useEnrolledCourses";
import { useAuth } from "../../../../context/AuthContext";

const LearningPathsList = () => {
    const navigate = useNavigate();
    const { refreshTokenSilently, isAuthenticated } = useAuth();
    const [isRefreshing, setIsRefreshing] = useState(false);
    
    // Use the shared hook - limit to 3 courses with no descriptions for dashboard
    const { formattedCourses, isLoading, error, refetch } = useEnrolledCourses({
        limit: 3,
        showDescription: false
    });

    // Navigate to course details page
    const handleResumeCourse = (courseId, batchId, courseTitle) => {
        console.log(`Resuming course: ${courseTitle}`);
        console.log(`Course ID: ${courseId}, Batch ID: ${batchId}`);
        navigate(`/learning/courses/course?courseId=${courseId}&batchId=${batchId}`);
    };

    // Handle retry with token refresh
    const handleRetry = async () => {
        setIsRefreshing(true);
        try {
            // Try to refresh token first if authentication issue
            const refreshed = await refreshTokenSilently();
            
            // Whether refresh succeeded or not, try refetching
            // If token is valid, this will work
            // If not, the component will handle the error
            refetch();
            
            // If token is invalid and we couldn't refresh, redirect to login
            if (!refreshed && !isAuthenticated()) {
                setTimeout(() => {
                    navigate('/login', { replace: true });
                }, 500);
            }
        } catch (error) {
            console.error("Error during retry:", error);
        } finally {
            setIsRefreshing(false);
        }
    };

    // Show loading state
    if (isLoading || isRefreshing) {
        return (
            <div className="space-y-4">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="w-full h-16 bg-gray-100 animate-pulse rounded-lg"></div>
                ))}
            </div>
        );
    }

    // Show error state
    if (error) {
        return (
            <div className="text-red-500 text-sm p-3 bg-red-50 rounded-md">
                <p>{error}</p>
                <button 
                    onClick={handleRetry} 
                    className="mt-2 text-blue-500 underline text-xs"
                    disabled={isRefreshing}
                >
                    {isRefreshing ? "Trying..." : "Try again"}
                </button>
            </div>
        );
    }

    // Show empty state if no courses
    if (!formattedCourses || formattedCourses.length === 0) {
        return (
            <div className="text-center py-3 text-gray-500 text-sm">
                No enrolled courses found.
            </div>
        );
    }

    // Render Resume buttons with proper navigation handlers
    const renderRightComponent = (item, index) => {
        return (
            <Button
                text="Resume"
                state="Default"
                type="Secondary"
                variant="Default"
                onClick={() => handleResumeCourse(item.courseId, item.batchId, item.title)}
                className="ml-2"
            />
        );
    };

    return (
        <div className="max-w-full">
            <CustomizableList
                items={formattedCourses}
                width="w-full"
                gap={2}
                renderRightComponent={renderRightComponent}
                className="space-y-4"
            />
        </div>
    );
};

export default LearningPathsList;